// extracted by mini-css-extract-plugin
module.exports = {"button":"DeleteAccountModal-module--button--2Zddp"};